import React, { useEffect, useState } from "react";
import api, { img, money } from "../../lib/api";
import { AdminHeader } from "./AdminLayout";
import { toast } from "sonner";

export default function AdminInventory() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/inventory").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async (p, available, threshold) => {
    await api.put(`/admin/inventory/${p.id}`, { available: Number(available), low_stock_threshold: Number(threshold) });
    toast.success("Inventory updated"); load();
  };
  return (
    <div>
      <AdminHeader title="Inventory" subtitle="Manage stock levels" />
      <div className="bg-white border border-sage/30 rounded-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-sage/30 text-left text-forest/50 text-xs uppercase"><th className="p-3">Product</th><th className="p-3">SKU</th><th className="p-3">Sold</th><th className="p-3">Available</th><th className="p-3">Low @</th><th className="p-3"></th></tr></thead>
          <tbody>
            {items.map((p) => <Row key={p.id} p={p} onSave={save} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
function Row({ p, onSave }) {
  const [a, setA] = useState(p.inventory?.available ?? 0);
  const [t, setT] = useState(p.inventory?.low_stock_threshold ?? 10);
  const low = Number(a) <= Number(t);
  return (
    <tr className={`border-b border-sage/15 ${low ? "bg-brown/5" : ""}`}>
      <td className="p-3 flex items-center gap-2"><img src={img((p.images || [])[1] || p.images?.[0])} alt="" className="h-10 w-8 object-cover bg-beige/40" />{p.name}</td>
      <td className="p-3 text-forest/50">{p.sku}</td>
      <td className="p-3">{p.sold}</td>
      <td className="p-3"><input value={a} onChange={(e) => setA(e.target.value)} className="w-20 border border-sage/40 px-2 py-1 rounded-sm" data-testid={`inv-avail-${p.slug}`} /></td>
      <td className="p-3"><input value={t} onChange={(e) => setT(e.target.value)} className="w-16 border border-sage/40 px-2 py-1 rounded-sm" /></td>
      <td className="p-3"><button onClick={() => onSave(p, a, t)} className="bg-forest text-ivory px-3 py-1 text-xs" data-testid={`inv-save-${p.slug}`}>Save</button></td>
    </tr>
  );
}
